<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import LineAlertCircle from '../../icons/LineAlertCircle.vue'
import type { Dialog } from './types'

withDefaults(defineProps<Dialog>(), {
  icon: LineAlertCircle,
  placement: 'center',
  size: 'xs',
})

const emit = defineEmits<{
  (e: 'close', value?: boolean): void
}>()

const isModalOpen = ref(false)
onMounted(() => {
  isModalOpen.value = true
})
const closeModal = (resp?: boolean) => {
  isModalOpen.value = false
  emit('close', resp)
}
</script>

<template>
  <DTModal
    :model-value="isModalOpen"
    :placement="placement"
    :size="size"
    @close="!requireAction && closeModal()"
  >
    <DTModalBody class="flex flex-col items-center justify-center gap-2.5 p-4 text-center text-base text-gray-600 md:p-6">
      <Component
        :is="icon"
        v-if="icon"
        class="size-6"
      />
      {{ message }}
    </DTModalBody>
    <DTModalFooter v-if="okTitle || cancelTitle">
      <DTButton
        v-if="cancelTitle"
        :variant="cancelVariant ?? 'default'"
        size="sm"
        @click="closeModal(false)"
      >
        {{ cancelTitle }}
      </DTButton>
      <DTButton
        v-if="okTitle"
        :variant="okVariant ?? 'blue'"
        size="sm"
        @click="closeModal(true)"
      >
        {{ okTitle }}
      </DTButton>
    </DTModalFooter>
  </DTModal>
</template>
